export function headerInit() {
	document.addEventListener( 'DOMContentLoaded', () => {
		const openMenuOnHover = false; // Set to true to open menu on hover for desktop, false to only open on click.

		const submenuButton = document.querySelectorAll( '.open-submenu' );
		const allMenuItems = document.querySelectorAll( '.menu-item' );
		const parentMenuItems = document.querySelectorAll(
			'.menu-item-has-children'
		);

		// Helper function to close all menus
		const closeAllMenus = () => {
			allMenuItems.forEach( ( item ) => {
				if ( item.classList.contains( 'open' ) ) {
					item.classList.remove( 'open' );
					const button = item.querySelector( '.open-submenu' );
					if ( button ) {
						button.setAttribute( 'aria-expanded', 'false' );
					}
				}
			} );
		};

		// Helper function to toggle submenu
		const toggleSubmenu = ( subMenu ) => {
			subMenu.classList.toggle( 'open' );

			const currentActiveMenuItemParent = subMenu;
			allMenuItems.forEach( ( item ) => {
				// Close all other dropdown menus if menu is not active menu item.
				if (
					item.classList.contains( 'menu-item-has-children' ) &&
					item !== currentActiveMenuItemParent
				) {
					item.classList.remove( 'open' );
					const button = item.querySelector( '.open-submenu' );
					if ( button ) {
						button.setAttribute( 'aria-expanded', 'false' );
					}
				}
			} );

			// Update aria-expanded based on open state
			const button = subMenu.querySelector( '.open-submenu' );
			if ( button ) {
				if ( subMenu.classList.contains( 'open' ) ) {
					button.setAttribute( 'aria-expanded', 'true' );
				} else {
					button.setAttribute( 'aria-expanded', 'false' );
				}
			}
		};

		// Helper function to check if desktop
		const isDesktop = () => window.innerWidth >= 992;

		// Click handler for submenu buttons (works for both hover and click modes on desktop, required for keyboard navigation)
		if ( submenuButton.length > 0 ) {
			submenuButton.forEach( ( el ) => {
				el.addEventListener( 'click', ( event ) => {
					event.preventDefault();
					const subMenu = event.target.closest(
						'.menu-item-has-children'
					);
					if ( subMenu ) {
						toggleSubmenu( subMenu );
					}
				} );
			} );
		}

		// Hover handlers for desktop when openMenuOnHover is enabled
		if ( openMenuOnHover && isDesktop() ) {
			parentMenuItems.forEach( ( item ) => {
				let hoverTimeout;

				item.addEventListener( 'mouseenter', () => {
					clearTimeout( hoverTimeout );
					// Close other menus when hovering
					allMenuItems.forEach( ( otherItem ) => {
						if (
							otherItem !== item &&
							otherItem.classList.contains( 'open' )
						) {
							otherItem.classList.remove( 'open' );
							const button =
								otherItem.querySelector( '.open-submenu' );
							if ( button ) {
								button.setAttribute( 'aria-expanded', 'false' );
							}
						}
					} );
					// Open current menu
					item.classList.add( 'open' );
					const button = item.querySelector( '.open-submenu' );
					if ( button ) {
						button.setAttribute( 'aria-expanded', 'true' );
					}
				} );

				item.addEventListener( 'mouseleave', () => {
					// Debounce the close action to avoid flickering
					hoverTimeout = setTimeout( () => {
						item.classList.remove( 'open' );
						const button = item.querySelector( '.open-submenu' );
						if ( button ) {
							button.setAttribute( 'aria-expanded', 'false' );
						}
					}, 150 );
				} );
			} );
		}

		// Close menu if user clicks outside of menu, when menu is open (applies to both modes)
		window.addEventListener( 'click', ( e ) => {
			const menu = document.getElementById( 'menu' );
			if ( menu && ! menu.contains( e.target ) ) {
				closeAllMenus();
			}
		} );

		// Header open logic
		const siteNav = document.getElementById( 'site-navigation' );
		const mobileNavOpen = document.getElementById( 'main-navigation-open' );
		const mobileNavClose = document.getElementById( 'main-navigation-close' );

		const openMobileHeader = () => {
			siteNav.classList.add( 'active' );
			siteNav.removeAttribute( 'inert' );
			const firstLink = siteNav.querySelector( 'a' );
			if ( firstLink ) {
				firstLink.focus();
			}
		};

		const closeMobileHeader = () => {
			siteNav.setAttribute( 'inert', '' );
			setTimeout( () => {
				// Without timeout focus doesn't get focus to close button.
				document.getElementById( 'main-navigation-open' ).focus();
			}, 10 );

			siteNav.classList.remove( 'active' );
		};

		mobileNavOpen.addEventListener( 'click', openMobileHeader );
		mobileNavClose.addEventListener( 'click', closeMobileHeader );

		// Handle resizing and based on the screen size,
		// close menu overlay on desktop.
		window.addEventListener( 'resize', () => {
			if ( window.innerWidth > 992 ) {
				siteNav.classList.remove( 'active' );
				closeAllMenus();
			}
		} );

		// Focus trapping example taken from: https://medium.com/@im_rahul/focus-trapping-looping-b3ee658e5177
		function MobileMenuKeyboardHandler( e ) {
			// Get all links from menu.
			const menuLinks = siteNav.getElementsByTagName( 'a' );

			if ( menuLinks && menuLinks.length > 0 ) {
				// Get last link from menu.
				const lastLinkInMenuIndex = menuLinks.length - 1;
				// Get last link from menu.
				const lastLinkInMenu = menuLinks[ lastLinkInMenuIndex ];

				let lastParentLink = lastLinkInMenu;

				const lastListItemInMainMenu = lastLinkInMenu.closest(
					'.menu-item-has-children'
				);
				if (
					lastListItemInMainMenu &&
					! lastListItemInMainMenu.classList.contains( 'open' )
				) {
					lastParentLink =
						lastListItemInMainMenu.querySelector( 'a+button' );
				}

				if ( e.key === 'Tab' ) {
					// Rotate Focus
					// eslint-disable-next-line @wordpress/no-global-active-element
					if (
						e.shiftKey &&
						document.activeElement === mobileNavClose
					) {
						e.preventDefault();
						if ( lastParentLink !== lastLinkInMenu ) {
							lastParentLink.focus();
						} else {
							lastLinkInMenu.focus();
						}
						// eslint-disable-next-line @wordpress/no-global-active-element
					} else if (
						! e.shiftKey &&
						( document.activeElement === lastLinkInMenu ||
							document.activeElement === lastParentLink )
					) {
						e.preventDefault();
						mobileNavClose.focus();
					}
				}
			}
			
			// Close submenus when pressing escape key.
			if ( e.key === 'Escape' ) {
				if ( siteNav.classList.contains( 'active' ) ) {
					closeMobileHeader();
					mobileNavOpen.focus();
				}
			}
		}
		document.addEventListener( 'keydown', MobileMenuKeyboardHandler );

		// Keyboard support for hover menus on desktop (Escape to close)
		document.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' && openMenuOnHover && isDesktop() ) {
				closeAllMenus();
			}
		} );

		handleAriaRole();
	} );

	function handleAriaRole() {
		const dialog = document.getElementById( 'site-navigation' );
		if ( ! dialog ) {
			return;
		}
		// When DOM is loaded role attribute will be added to navigation.
		if ( window.innerWidth < 992 ) {
			dialog.setAttribute( 'role', 'dialog' );
			dialog.setAttribute( 'aria-modal', 'true' );
			dialog.setAttribute( 'inert', '' );
		}

		// Handle resizing and based on the screen size,
		// role will be added or removed from navigation.
		window.addEventListener( 'resize', () => {
			if ( window.innerWidth < 992 ) {
				dialog.setAttribute( 'role', 'dialog' );
				dialog.setAttribute( 'aria-modal', 'true' );
				dialog.setAttribute( 'inert', '' );
			} else {
				dialog.removeAttribute( 'role' );
				dialog.removeAttribute( 'aria-modal' );
				dialog.removeAttribute( 'inert' );
			}
		} );
	}
}